import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { Assignment, Ballot, Visibility } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Button from 'components/CustomButtons/Button.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { wsFindBy } from 'services/WService.js';
import { WithApp } from 'contexts/appContext';

import ModalOrderDetail from './Modal/OrderDetailModal';
import { currency } from 'hooks/Pipe';
import { Tooltip } from '@material-ui/core';
import { useModal } from 'hooks/useModal';
import OrderTransactionModal from 'components/Tvendo/Order/OrderTransactionModal';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'ID', accessor: 'id', width: 100 },
  { Header: 'Inicio ped.', accessor: 'start_date', width: 200 },
  { Header: 'Cierre ped.', accessor: 'end_date', width: 200 },
  { Header: 'Dirección', accessor: 'Address2' },
  { Header: 'Térm. pago', accessor: 'PymntGroup', width: 130 },
  { Header: 'Vendedor', accessor: 'SlpName', width: 350 },
  { Header: 'Canal', accessor: 'base_canal_description', width: 150 },
  { Header: 'Razón prioridad', accessor: 'base_reason_description_priority', width: 150 },
  { Header: 'Fuerza venta', accessor: 'base_sale_force_id', width: 150 },
  { Header: 'Total paq.', accessor: 'total_packages', width: 100 },
  { Header: 'Mto. bruto', accessor: 'gross_amount', width: 100 },
  { Header: 'Desc.', accessor: 'discount', width: 100 },
  { Header: 'Mto. desc.', accessor: 'discount_amount', width: 100 },
  { Header: 'Mto. total', accessor: 'total_amount', width: 100 },
  { Header: 'Cód. movil', accessor: 'movil_uuid', width: 300 },
  { Header: 'Comentario', accessor: 'comment', width: 300 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function Order(props) {
  const classes = useStyles();
  const bPartner = props.businessPartner;

  const [orders, setOrders] = useState([]);
  const [openDetailId, setOpenDetailId] = useState(null);
  const [open, setOpen] = useState(false);
  const [logModel, setLogModalOpen] = useModal();

  async function listOrder() {
    let response = await wsFindBy('ordm/order', 'base_business_partner_id', bPartner.id);
    if (response.success) setOrders(response.data);
  }

  useEffect(() => {
    listOrder();
  }, []);

  return (
    <>
      <ModalOrderDetail
        title={'Pedidos-de-socio-' + bPartner.CardCode}
        openDetailId={openDetailId}
        setOpenDetailId={setOpenDetailId}
        open={open}
        setOpen={setOpen}
      />
      <OrderTransactionModal model={logModel} setOpen={setLogModalOpen} entity="ordm/order" />
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de Pedidos</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            formatDate="YYYY-MM-DD"
            excelName={'Pedidos-de-socio-' + bPartner.CardCode}
            defaultWidth={3100}
            columns={columns}
            data={orders.map((order, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <Button
                      justIcon
                      round
                      simple
                      color={props.themeContext.buttonColor}
                      onClick={() => {
                        setOpenDetailId(order.id);
                        setOpen(true);
                      }}
                    >
                      <Visibility />
                    </Button>
                    <Tooltip title="Logs">
                      <Button
                        justIcon
                        round
                        simple
                        color="warning"
                        onClick={() => {
                          setLogModalOpen(order);
                        }}
                      >
                        <Ballot />
                      </Button>
                    </Tooltip>
                  </div>
                ),
                id: order.id.toString(),
                start_date: order.start_date,
                end_date: order.end_date,
                Address2: order.Address2,
                PymntGroup: order.PymntGroup,
                SlpName: order.SlpName,
                base_canal_description: order.base_canal_description,
                base_reason_description_priority: order.base_reason_description_priority,
                base_sale_force_id: order.base_sale_force_id,
                total_packages: order.total_packages,
                gross_amount: currency(order.gross_amount),
                discount: order.discount,
                discount_amount: currency(order.discount_amount),
                total_amount: currency(order.total_amount),
                movil_uuid: order.movil_uuid,
                comment: order.comment,
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
